module.exports = __webpack_public_path__ + "img/ok.c47702cd.svg";